// extracted by mini-css-extract-plugin
module.exports = {"filters-section":"FiltersSection_filters-section__3rTDL"};